import { render, staticRenderFns } from "./brandIndexTips.vue?vue&type=template&id=1fe9b5b8&scoped=true&"
import script from "./brandIndexTips.vue?vue&type=script&lang=js&"
export * from "./brandIndexTips.vue?vue&type=script&lang=js&"
import style0 from "./brandIndexTips.vue?vue&type=style&index=0&id=1fe9b5b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9b5b8",
  null
  
)

export default component.exports